export const dict = {
  'en': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n3.After registering your THETA, reboot Smart Device Plug-in.\n\nInstructions on how to use Smart Device Plug-in\n1.Tap the registered THETA.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'ja': {
    'SmartDevice': 'Smart Device',
    'Login': "ログイン",
    'Sign In': "サインイン",
    'Sign Up': "サインアップ",
    'Sign Out': "ログアウト",
    'hello': "こんにちは ",
    'Greeting': "ログインしてください",
    'error': "エラーが発生しました。リロードしてください",
    'move': "撮影画面に移動",
    'delete': "このTHETAを削除",
    'loading': "読み込み中...",
    'connected theta': "接続先",
    'not connected': "なし",
    'register theta': "接続中のTHETAを登録する",
    'use CloudUpload': "File Cloud Upload V2 プラグインと連携する",
    'return': "戻る",
    'retry': "再実行",
    'detect theta': "登録したいカメラの無線ボタンを押してください。",
    'register header title': "THETAを登録",
    'failed to detect': "THETAを検出できませんでした",
    'auto': "オート",
    'aperture': "絞り優先",
    'shutter priority': "シャッター優先",
    'iso priority': "ISO 優先",
    'manual': "マニュアル",
    'off': "OFF",
    'DR': "DR 補正",
    'noise': "ノイズ低減",
    'HDR': "HDR 合成",
    'finish': "終了",
    'network id': 'ネットワーク名',
    'name introduction': '登録名を変更したい場合は入力してください',
    'upper introduction': '接続方法\n1．THETA本体の接続準備\nTHETA本体の無線ボタンを押すことでCLモードに切り替えることができます。\nCLモードになるとTHETA本体の無線アイコンが緑色に変わり点滅します。\nルータの接続に成功すると無線アイコンが緑色の点灯に変わります。\n2．「接続中のTHETAを登録する」からTHETAを登録してください。\n3．登録が完了したらプラグインを再起動してください。\n\n使用方法\n1．登録したTHETAをタップしてください。\n2．「撮影画面に移動」を選択すると、撮影画面に遷移することができます。\n3．「このTHETAを削除」を選択すると、選択中のTHETAを削除することができます。',
    'lower introduction': 'File Cloud Upload V2 プラグインと連携すると、登録されているサービスに自動的にアップロードされます。\nFile Cloud Upload V2 プラグインの設定をしておく必要があります。',
    'input serial number': 'THETAと接続します。\n接続したいTHETAのシリアル番号を入力してください。',
    'next': "次へ",
    'cancel': "キャンセル",
    'register name': "登録名",
    'theta is detected': "THETAが検出されました",
    'confirm delete': "THETAを削除しますか？",
    'yes': "はい",
    'no': "いいえ",
    'image capturing': "撮影中です。操作できません",
    'video capturing': "撮影中です。停止ボタン以外操作できません",
    'waiting': "待機中",
    'plugin off or uploading': "プラグインが起動していないか、ファイルアップロード中です",
    'plugin off': "プラグインを起動してください",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'アカウント削除',
    'unsubscribe account title':'アカウントを削除します',
    'unsubscribe account text':'アカウント情報が削除されるとアカウントに紐づく情報もすべて削除されます｡アカウント削除の操作を一度行うと取り消すことができません｡よろしればOKボタンをおしてください｡',
    'agree privacy policy checkbox':'プライバシーポリシーに同意します',
    'agree privacy policy':'を読み、同意の上、アカウント登録してください。',
    'privacy policy':'プライバシーポリシー',
    'unsubscribe account finish title':'アカウント削除完了',
    'unsubscribe account finish text':'アカウントが削除されました。\nSmart Device プラグインをご利用いただきありがとうございました。'  
  },
  'fr': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'es': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'de': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'it': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'zh': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
  'ko': {
    'SmartDevice': 'Smart Device',
    'Login': "Login",
    'Sign In': "Sign in",
    'Sign Up': "Sign up",
    'Sign Out': "Logout",
    'hello': "Hello ",
    'Greeting': "Please sign in.",
    'error': "An error occurred. Please reload the page.",
    'move': "Move to shooting page",
    'delete': "Unregister this THETA",
    'loading': "Loading...",
    'connected theta': "Access point",
    'not connected': "Not connected",
    'register theta': "Register the connected THETA",
    'register header title': "Register your THETA",
    'use CloudUpload': "Link with File Cloud Upload V2 Plug-in",
    'return': "Return",
    'retry': "Retry",
    'detect theta': "Please press the Wireless button on the THETA you want to register.",
    'failed to detect': "No THETA was able to be detected.",
    'auto': "Auto",
    'shutter priority': "Shutter priority",
    'aperture': "Aperture priority",
    'iso priority': "ISO priority",
    'manual': "Manual",
    'off': "OFF",
    'DR': "DR compensat.",
    'noise': "Noise reduct.",
    'HDR': "HDR Rendering",
    'finish': "Finish",
    'network id': 'Network name',
    'name introduction': 'Please enter the information if you want to change the registered name',
    'upper introduction': 'Instructions on how to connect with THETA \n 1.Preparing to connect \nYou can switch to Client Mode by pressing the Wireless button on the side of THETA. \n The wireless LED will turn green and blink when your THETA is set to Client Mode. \n When your THETA connects with the router successfully, the wireless LED will be solid green.\n2.Select \'Register the connected THETA\' to register your THETA.\n\nInstructions on how to use Smart Device Plug-in\n1.After registering your THETA, select the camera you want to connect to from the connection destination list.\n2.Select \'Move to shooting page\' to take pictures or movies.\n3.Select \'Unregister this THETA\' to unregister your THETA.',
    'lower introduction': 'When you enable the File Cloud Upload V2 Plug-in, photos and movies will be automatically uploaded to the designated account on Google Drive.\nIt is necessary to configure the File Cloud Upload V2 Plug-in first.',
    'input serial number': 'Connect to the THETA. Please enter the serial number of THETA you want to connect to.',
    'next': "Next",
    'cancel': "Cancel",
    'register name': "Registered Name",
    'theta is detected': "THETA is detected",
    'confirm delete': "Are you sure that you want to delete THETA?",
    'yes': "Yes",
    'no': "No",
    'image capturing': "Currently in use. You can not operate THETA.",
    'video capturing': "Currently in use. Operation other than using the stop button is not possible.",
    'waiting': "Ready",
    'plugin off or uploading': "The Plug-in is not booted or files are currently being uploading.",
    'plugin off': "Please boot the Plug-in",
    'ok': "OK",
    'back': "Back",
    'unsubscribe account':'Unsubscribe Account',
    'unsubscribe account title':'Unsubscribe Account',
    'unsubscribe account text':'If this account is unsubscribesd, the account information will be deleted.Once account unsubscribe operation is done, it can not be canceled.Press the OK button to continue.',
    'agree privacy policy checkbox':'Agree to Privacy policy',
    'agree privacy policy':'Please read and agree to Privacy policy and then register your account.',
    'privacy policy':'Privacy policy',
    'unsubscribe account finish title':'Unsubscribed',
    'unsubscribe account finish text':'Your Account has been unsubscribed.\n Thank you for using the Smart Device Plug-in.'  
  },
};



// WEBPACK FOOTER //
// ./src/dictionary.js